import { render, staticRenderFns } from "./OrdersNumber.vue?vue&type=template&id=45bff848&scoped=true"
import script from "./OrdersNumber.vue?vue&type=script&lang=ts"
export * from "./OrdersNumber.vue?vue&type=script&lang=ts"
import style0 from "./OrdersNumber.vue?vue&type=style&index=0&id=45bff848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bff848",
  null
  
)

export default component.exports